import { isFirefox, isSafari } from "@/lib/utils";

const getCustomAudioStream = (
  audioRef: React.MutableRefObject<HTMLAudioElement | null>,
  sourceNodeRef: React.MutableRefObject<MediaElementAudioSourceNode | null>,
  audioContextRef: React.MutableRefObject<AudioContext | null>
): MediaStream | null => {
  if (audioRef.current && !sourceNodeRef.current) {
    const audioContext = new (window.AudioContext || window.AudioContext)();
    audioContextRef.current = audioContext;
    const sourceNode = audioContext.createMediaElementSource(audioRef.current);
    const destination = audioContext.createMediaStreamDestination();
    sourceNode.connect(destination);
    sourceNodeRef.current = sourceNode;
    sourceNode.connect(audioContext.destination);
    return destination.stream;
  }
  return null;
};

const getDefaultAudioStream = (
  audioRef: React.MutableRefObject<HTMLAudioElement | null>
): MediaStream | null => {
  if (audioRef.current) {
    const audioElement = audioRef.current as unknown as {
      captureStream: () => MediaStream;
    };
    const stream = audioElement.captureStream();
    return stream;
  }
  return null;
};

export const getAudioStream = (
  audioRef: React.MutableRefObject<HTMLAudioElement | null>,
  sourceNodeRef: React.MutableRefObject<MediaElementAudioSourceNode | null>,
  audioContextRef: React.MutableRefObject<AudioContext | null>
): MediaStream | null => {
  if (isSafari() || isFirefox()) {
    return getCustomAudioStream(audioRef, sourceNodeRef, audioContextRef);
  } else {
    return getDefaultAudioStream(audioRef);
  }
};
